import React, { useEffect, useState } from 'react';
import useStore from "../../../StorePeople/Store";
import styles from './styles.module.css'; // Import your CSS module

function JobTitle() {
    const { title, setTitle, isQueryLoading } = useStore();
    const [inputValue, setInputValue] = useState(title);

    const handleChange = (event) => {
        setInputValue(event.target.value);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setTitle(inputValue);
        }, 1000);

        return () => clearTimeout(timer);
    }, [inputValue, setTitle]);

    useEffect(() => {
        setInputValue(title)
    }, [title])



    return (
        <div className={styles.titleContainerPeople}>
            <label className={styles.titlePeopleLabel}>Job title</label>
            <input type="text" className={styles.titleInputPeople} disabled={isQueryLoading} placeholder="VP of marketing" value={inputValue} onChange={handleChange} />
        </div>
    );
}

export default JobTitle;
